import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head } from '@cinch-nx/landing-ui-shared'
import {
  ComponentLayouts,
  StoryblokRendererV2 as StoryblokRenderer,
} from '@cinch-nx/storyblok-utils'

import styles from './autotrader.module.css'
import { AutotraderProps } from './get-static-props'
import { storyblokComponents } from './storyblok/data/storyblok-renderer-map'
import { AutotraderStory } from './storyblok/storyblok'

export const Autotrader = ({ story, preview }: AutotraderProps) => {
  const { content } = useStoryblokState<AutotraderStory>({
    story,
    enableBridge: preview,
  })

  const SEO = content.SEO?.[0] ?? {}

  const { WhyChooseSection, ...restComponents } = storyblokComponents
  const componentLayouts: ComponentLayouts = {
    fullWidthWrapper: { WhyChooseSection },
    slimWrapper: restComponents,
  }

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Autotrader - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />
      <article className={styles.pageWrapper}>
        <StoryblokRenderer block={content.body} components={componentLayouts} />
      </article>
    </>
  )
}
